import type { UploadProps, } from "element-plus"
import { getToken, } from "@/hooks/useToken.ts"

export interface ExternalProps {
  sizeLimit?: number
  hideOnExceeded?: boolean
  typeMsg?: string
  sizeExceededMsg?: string
  limitExceededMsg?: string
  modelValue?: BaseFileDTO[]
}

export type Props = Partial<UploadProps> & ExternalProps

export const externalPropKeys: (keyof ExternalProps)[] = [
  "sizeLimit",
  "modelValue",
  "hideOnExceeded",
  "sizeExceededMsg",
  "limitExceededMsg",
]

export const defaultProps = {
  modelValue: () => [],
  limit: 0,
  accept: "",
  sizeLimit: 0,
  autoUpload: true,
  showFileList: true,
  hideOnExceeded: true,
  headers: () => ({
    "x-sso-auth": getToken(),
  }),
}
